'use strict';

const { queryAll, queryFirst, addClass, removeClass, hasClass, matchesBreakpoint } = require('../domUtil');
const { tileImageHoverHandler, autoPlayPauseOnVisibility } = require('../product/helper');
const { PLPTileImageTemplate, PLPTileVideoTemplate } = require('../templates');
const $body = $('body');
const { HIDDEN_CLASS } = require('../constants');
import { getNestedValue } from '../util';

const handleSwatchClickUpdates = () => {
    const selectedClass = 'selected';
    const badgeHideClass = 'hide';
    const badgeShowClass = 'show';
    $(document).on('click', '.clickable-swatch, .non-color-attribute', function (e) {
        e.preventDefault();
        const el = this;
        const productTileWrapper = el.closest('.product-tile-wrapper');
        const quickBuyContainer = el.closest('.quick-buy');
        const productTile = queryFirst('.product-tile', productTileWrapper);
        const imageIndicators = queryFirst('.carousel-indicators', productTileWrapper);
        const productTileId = queryFirst('.js-plp-grid-slider', productTileWrapper);
        const elImgContainer = queryFirst('.carousel-inner', productTile);
        const elSwatchContainer = queryFirst('.color-swatches', productTile);
        const elLoyaltyProductBadgeContainer = queryFirst('.loyalty-product-tile-badge', productTile);
        const addToWishlistIconPlp = queryFirst('.add-to-wish-list-container', productTile);
        const loyaltyEarlyAccessLockPlp = queryFirst('.loyalty-early-access-lock-container', productTile);
        const isLoyaltyHeaderProfile = getNestedValue(window, 'johnnyWasUtils.profile') || {};
        const { isLoyaltyProgramMember, isLoyaltyEnabled } = isLoyaltyHeaderProfile;
        const elProductBadgeContainer = queryFirst('.product-tile-badge', productTile);
        const elProductBadgeTxt = queryFirst('.product-tile-badge-text', productTile);
        const elTileImgURL = queryFirst('.tile-img-link', productTile);
        const elProductName = queryFirst('.pdp-link .product-name a', productTile);
        const elProductMoreColors = queryAll('.swatches-more-colors', productTile);
        const sizeContainer = matchesBreakpoint('lg') ? queryFirst('div.quick-buy ul.size-container', productTileWrapper) : queryFirst('div.quick-buy-modal ul.size-container', productTileWrapper);
        const elFitSizeContainer = matchesBreakpoint('lg') ? queryFirst('div.quick-buy ul.non-color-container', productTileWrapper) : queryFirst('div.quick-buy-modal ul.non-color-container', productTileWrapper);

        addClass(elProductBadgeContainer, badgeHideClass);
        removeClass(elProductBadgeContainer, badgeShowClass);
        const data = el.dataset;
        const url = data.swatchurl || data.url;
        const spinner = $.spinner();

        if (quickBuyContainer) {
            $(quickBuyContainer).spinner().start();
        } else {
            spinner.start();
        }

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                // handle image update on swatch click
                const { category_id } = window.utag_data || {};
                let imageData = data.product.images.medium;
                const imageDataLength = imageData.length;
                const videoFile = data.product.videoFile;
                const videoThumbnailImage = data.product.videoThumbnailImage;
                const isVideoPrimaryPLP = data.product.isVideoPrimaryPLP;

                let tileIndicatorTmp = '';
                let sliderTmp = '';
                $body.trigger('swatchClickEvent', el.closest('.product-tile'));
                if ($(el).hasClass('clickable-swatch')) {
                    removeClass(queryAll('.clickable-swatch', elSwatchContainer), selectedClass);
                } else {
                    removeClass(queryAll('.non-color-attribute', elFitSizeContainer), selectedClass);
                }
                addClass(el, selectedClass);

                const { merchAltImageParams } = data.product;
                if (merchAltImageParams) {
                    for (let i = 0, n = merchAltImageParams.length; i < n; i++) {
                        const params = merchAltImageParams[i].split(",");
                        const [categoryId, swapIndex] = params;
                        let adjustedSwapIndex = swapIndex - 1;
                        if (category_id === categoryId && adjustedSwapIndex >= 0 && adjustedSwapIndex < imageDataLength) {
                            //Add selected image to front of image queue, shift all others over
                            imageData = imageData.splice(adjustedSwapIndex, 1).concat(imageData);
                        }
                    }
                }

                const slideTotal = videoFile && isVideoPrimaryPLP ? imageDataLength + 1 : imageDataLength;

                if (videoFile && isVideoPrimaryPLP) {
                    sliderTmp += `
                        <div class="carousel-item active" role="option" aria-label="Slide 1 of ${slideTotal}">
                            ${PLPTileVideoTemplate(videoFile, videoThumbnailImage)}
                        </div>`;
                    tileIndicatorTmp += `<li class="active" data-target="#${productTileId ? productTileId.id : ''}" data-slide-to="0">
                        </li>`;
                }

                let lastImage = imageData.find(image => image.url.indexOf('catalog') > -1) || imageData[imageData.length - 1];

                imageData.forEach((el, i) => {
                    const slideNumber = videoFile && isVideoPrimaryPLP ? i + 2 : i + 1;
                    sliderTmp += `
                    <div class="carousel-item${(!videoFile || !isVideoPrimaryPLP) && i === 0 ? ' active' : ''}" role="option" aria-label="Slide ${slideNumber} of ${slideTotal}">
                          ${PLPTileImageTemplate(el, i, lastImage)}
                    </div>`;
                    tileIndicatorTmp += `<li class="${(!videoFile || !isVideoPrimaryPLP) && i === 0 ? ' active' : ''}" data-target="#${productTileId ? productTileId.id : ''}" data-slide-to="${videoFile && isVideoPrimaryPLP ? i + 1 : i}">
                    </li>`;
                });

                // handle badging update on swatch click
                const { productBadge, product } = data;
                const { earlyAccess } = product;
                addClass(loyaltyEarlyAccessLockPlp, HIDDEN_CLASS);
                removeClass(addToWishlistIconPlp, HIDDEN_CLASS);
                addClass(elLoyaltyProductBadgeContainer, badgeHideClass);
                if (isLoyaltyEnabled && earlyAccess && earlyAccess.isEarlyAccessProduct) {
                    if (!isLoyaltyProgramMember) {
                        addClass(addToWishlistIconPlp, HIDDEN_CLASS);
                        removeClass(loyaltyEarlyAccessLockPlp, HIDDEN_CLASS);
                    } else {
                        removeClass(addToWishlistIconPlp, HIDDEN_CLASS);
                        addClass(loyaltyEarlyAccessLockPlp, HIDDEN_CLASS);
                    }
                    removeClass(elLoyaltyProductBadgeContainer, badgeHideClass);
                    addClass(elProductBadgeContainer, badgeHideClass);
                    removeClass(elProductBadgeContainer, badgeShowClass);
                } else if (productBadge && productBadge.badgeText.length) {
                    removeClass(elProductBadgeContainer, badgeHideClass);
                    if (productBadge.badgeTextColor) {
                        elProductBadgeTxt.setAttribute('style', `color:${productBadge.badgeTextColor}`);
                    }
                    if (productBadge.badgeBgColor) {
                        elProductBadgeContainer.style.setProperty('--badge-bg-color', `${productBadge.badgeBgColor}`);
                    }
                    if (productBadge.badgeBgOpacity) {
                        elProductBadgeContainer.style.setProperty('--badge-bg-opacity', `${productBadge.badgeBgOpacity}%`);
                    }
                    elProductBadgeTxt.textContent = productBadge.badgeText;
                } else {
                    addClass(elProductBadgeContainer, badgeHideClass);
                    removeClass(elProductBadgeContainer, badgeShowClass);
                }

                // handle img link update on swatch click
                const { tileImageUrl, id, quickViewURL, productDetailsUrl } = data.product;

                if (tileImageUrl && tileImageUrl.length) {
                    elTileImgURL.href = tileImageUrl;
                }

                const productTile = el.closest('.product');
                productTile.dataset.pid = id;
                productTile.dataset.wishlistId = id;
                const wishlistButton = queryFirst('.add-to-wish-list', productTile);
                if (wishlistButton && hasClass(wishlistButton, 'added-to-wish-list')) {
                    removeClass(wishlistButton, 'added-to-wish-list');
                    const assistiveText = wishlistButton.getAttribute('data-assistive-text');
                    wishlistButton.setAttribute('aria-label', assistiveText);
                }

                const quickviewButton = queryFirst('.quickview', productTile);
                if (quickviewButton && quickViewURL) {
                    quickviewButton.dataset.href = quickViewURL;
                }

                const variationAttributes = data.product.variationAttributes.length ? data.product.variationAttributes : {};
                let li = '';
                let fitSizeLi = '';
                variationAttributes.forEach((variationAttr, i) => {
                    if (variationAttr.attributeId === 'size') {
                        const sizes = variationAttr.values ? variationAttr.values : {};
                        sizeContainer.innerHTML = '';
                        if (Object.keys(sizes).length) {
                            let title = $('.quick-buy-notifyme .select-size-label').val().split(':');
                            sizes.forEach((size, i) => {
                                li += `
                                <li class="size-list">
                                    <button title="${title[0]}: ${size.id}"
                                    class="btn size-btn quick-add-to-cart ${size.selected ? 'selected' : ''} ${!size.inStock || size.forceOutOfStock || product.isDirectlyPurchasable === false || size.isRestricted ? 'not-available' : ''}"
                                    data-attr-url="${size.url}" data-attr-value="${size.id}"
                                    data-value-id="${size.id}"
                                    aria-label="${title[0]} ${size.id}"
                                    data-gtmdata='${JSON.stringify(product.gtmData)}'
                                    data-gtmga4data='${JSON.stringify(product.gtmGA4Data)}'
                                    data-variation-id="${size.variantID}"
                                    data-stock-notification="${size.stockNotificationAllowed}">
                                    ${size.id}
                                    </button>
                                </li>`;
                            });
                            sizeContainer.innerHTML = li;
                        }
                    } else if (variationAttr.attributeId === 'fitSize') {
                        const fitSizes = variationAttr.filteredValues ? variationAttr.filteredValues : {};
                        let selected = '';
                        if (Object.keys(fitSizes).length) {
                            const selectedIndex = fitSizes.findIndex(item => item.selected === true);
                            fitSizes.forEach((fitSize, i) => {
                                if (selectedIndex != -1) {
                                    selected = fitSizes[selectedIndex].id === fitSize.id;
                                } else {
                                    selected = fitSizes[0].id === fitSize.id;
                                }
                                if ($(el).hasClass('clickable-swatch')) {
                                    if (selected && selectedIndex > -1) {
                                        elProductName.href = product.selectedProductTileUrl || elProductName.href;
                                        elTileImgURL.href = elProductName.href;
                                    }
                                    if (elFitSizeContainer) {
                                        elFitSizeContainer.innerHTML = '';
                                    }

                                    fitSizeLi += `
                                        <li class="non-color-list fitsize-swatches">
                                            <button title="${fitSize.id}"
                                            class="btn non-color-attribute fit-product-type ${selected ? 'selected' : ''} ${!fitSize.inStock || fitSize.forceOutOfStock || product.isDirectlyPurchasable === false ? 'not-available' : ''}"
                                            aria-label="${variationAttr.displayName} ${fitSize.displayValue}"
                                            data-fitsizeswatch-name="${fitSize.displayValue}" data-product-id="${product.id}"
                                            data-product-name="${product.productName}" data-url="${fitSize.url}" data-attr-value="${fitSize.value}"
                                            data-attr-displayValue="${fitSize.displayValue}" data-size-fitsize="${fitSize.id}" >
                                                <span class="oos-indicator"></span>
                                                <span data-attr-value="${fitSize.value}"
                                                    class="${fitSize.id}-value swatch-value fitSize-value ${selected ? 'selected' : ''} ${fitSize.selectable ? 'selectable' : 'unselectable'}"
                                                    data-attr-displayValue="${fitSize.displayValue}" >
                                                    ${fitSize.displayValue}
                                                </span>
                                            </button>
                                        </li>`;
                                } else {
                                    if (selected && elProductName) {
                                        elProductName.href = product.selectedProductTileUrl || elProductName.href;
                                        elTileImgURL.href = elProductName.href;
                                        elProductMoreColors.forEach(moreLink => {
                                            moreLink.href = elProductName.href;
                                        });
                                    }
                                    let $attrValue = $(productTile).find('.quick-buy [data-attr="' + variationAttr.attributeId + '"] [data-attr-value="' + fitSize.value + '"]');
                                    let $swatchButton = $attrValue.parent();
                                    $swatchButton.attr('data-product-id', data.product.id);
                                    if (fitSize.url) {
                                        $swatchButton.attr('data-url', fitSize.url);
                                    }
                                }
                            });
                            if ($(el).hasClass('clickable-swatch')) {
                                if (elFitSizeContainer) {
                                    elFitSizeContainer.innerHTML = fitSizeLi;
                                }
                                spinner.stop();
                                const fitSizeEle = $(productTile).find('ul.non-color-container li');
                                let requestedFitSize = data.queryString.split('&').find(param => param.includes('fitSize'))?.split('=')[1];
                                let fitSizeIncluded = fitSizes.find(fitSize => fitSize.id === requestedFitSize);
                                if (fitSizeEle.length && !fitSizeIncluded) {
                                    $(fitSizeEle).first().find('button.non-color-attribute').trigger('click');
                                }
                            }
                            if (fitSizes.length === 1) {
                                $(productTile).find('ul.non-color-container li.fitsize-swatches').hide();
                            }
                        }
                    }
                });
                if (elImgContainer) {
                    elImgContainer.innerHTML = sliderTmp;
                    imageIndicators.innerHTML = tileIndicatorTmp;
                }
                $body.trigger('swatchChangeEvent', el);
                if (queryAll('li', imageIndicators).length > 0) {
                    removeClass(imageIndicators, 'invisible');
                } else {
                    addClass(imageIndicators, 'invisible');
                }

                queryAll('.js-plp-image', elImgContainer).forEach(imageEl => {
                    tileImageHoverHandler(imageEl);
                });

                if (queryFirst('.js-plp-video video', elImgContainer)) {
                    $body.trigger('product:initVideos');
                    autoPlayPauseOnVisibility(queryFirst('.js-plp-video video', elImgContainer));
                }

                spinner.stop();
            },
            error: function () {
                spinner.stop();
            }
        });
    });
};

export default handleSwatchClickUpdates;
